import { render, staticRenderFns } from "./MIcon.vue?vue&type=template&id=cd2d3312&"
import script from "./MIcon.vue?vue&type=script&lang=js&"
export * from "./MIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports